import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dcb421fe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container margin__top__20" }
const _hoisted_2 = { class: "flex" }
const _hoisted_3 = { class: "col1" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "form__content margin__top__20" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_bookmark_form = _resolveComponent("bookmark-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.$store.state.bookmark?.editedBookmark?.name)
          ? (_openBlock(), _createElementBlock("h4", _hoisted_4, " Editing this bookmark "))
          : (_openBlock(), _createElementBlock("h4", _hoisted_5, " Adding a new bookmark ")),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_bookmark_form, { onSave: _ctx.saveBookmark }, null, 8, ["onSave"])
        ])
      ])
    ])
  ]))
}